import React, { Component, useEffect, useState } from 'react';
import Frame from '../images/Frame.svg';
import ContactPopup from './Popup';

function ConfirmationPopup({popup, message, clearValue}) {
  const [isOpen, setIsOpen] = useState(popup);
  useEffect(() => {
    setIsOpen(popup);
  }, [popup]);

  const openPopup = ()=>{
    setIsOpen(true)
  }
  const closeModal = (value)=>{
    clearValue(false);
  }
  return (
    <div>
    {!!isOpen && (<div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 ">
            <div className="relative bg-white rounded shadow-lg w-[90vw] max-w-2xl p-10">
          {/* <h2 className="text-lg font-semibold mb-4">Are you sure?</h2> */}
            <p className="mb-4 text-center">{message}</p>
          <div className="flex justify-center gap-2">
            <button className="bg-emerald-600 text-white py-2 px-4 rounded hover:bg-emerald-400" onClick={()=>closeModal()}>Close</button>
          </div>
        </div>
      </div>
    )}
    </div>
  )
}

export default ConfirmationPopup;